import { put, takeLatest, call } from 'redux-saga/effects';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { fetchUnitTypeByIdError, fetchUnitTypeByIdSuccess, fetchUnitTypesError, fetchUnitTypesSuccess } from '../reducers/unitTypeReducer';
import UnitTypeApi from '../api/unitTypeApi';
import UnitType from '../interfaces/output/unitType';
import { PayloadAction } from '@reduxjs/toolkit';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';

function* doFetchUnitType(action: PayloadAction<string>) {
    const unitGroupId = action.payload;
    try {
        const response: UnitType = yield call(UnitTypeApi.fetchUnitType, unitGroupId);
        yield put(fetchUnitTypeByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchUnitTypeByIdError(error as HttpErrorResponse));
    }
}

function* doFetchUnitTypes(action: PayloadAction<{ paging: Paging }>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<UnitType> = yield call(UnitTypeApi.fetchUnitTypes, paging);
        yield put(fetchUnitTypesSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchUnitTypesError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('unitType/fetchUnitTypeById', doFetchUnitType),
    takeLatest('unitType/fetchUnitTypes', doFetchUnitTypes)
];

